import React from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '../store'
import { useAudioPlayer } from '../pages/Main/components/useAudioPlayer'
import { AUDIO_MAIN_URL } from '../constants/audioAssets'

const START_MUSIC_PATHS = ['/start', '/select-main-character']

function isStartMusicRoute(pathname: string): boolean {
  return START_MUSIC_PATHS.includes(pathname)
}

/**
 * Plays start music on start page and main character select page.
 */
export const StartMusicPlayer: React.FC = () => {
  const location = useLocation()
  const backgroundMusicEnabled = useSelector((state: RootState) => state.app.settings.backgroundMusicEnabled)
  const musicVolume = useSelector((state: RootState) => state.app.settings.musicVolume)
  const musicDucked = useSelector((state: RootState) => state.app.settings.musicDucked)

  const isStart = isStartMusicRoute(location.pathname)
  const shouldPlay = backgroundMusicEnabled && isStart && !musicDucked

  const audioRef = useAudioPlayer({
    backgroundMusicEnabled: shouldPlay,
    musicVolume,
  })

  return (
    <audio
      ref={audioRef}
      src={AUDIO_MAIN_URL}
      loop
      preload="metadata"
      onError={(e) => {
        console.error('Start music loading error:', e)
      }}
    />
  )
}
